import { c as _c } from "react/compiler-runtime";
import { BestOfAwardsBanner } from '@cc-shopping/ui/composites/BestOfAwardsBanner';
import { BEST_OF_AWARDS_WINNERS_MAP } from '@cc-shopping/ui/composites/BestOfAwardsBanner/utils';
import customImageWidthURLBuilder from '@cc-shopping/utils/custom-image-width-url-builder';
import { Box } from '@mui/material';
import ApplyNowButton from 'src/app/credit-cards/reviews/components/Body/Summary/ProductCard/components/ApplyNowButton';
import CardImage from 'src/app/credit-cards/reviews/components/Body/Summary/ProductCard/components/CardImage';
import RatesAndFeesButton from 'src/app/credit-cards/reviews/components/Body/Summary/ProductCard/components/RatesAndFeesButton';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import ApplyNowTitle from '../components/ApplyNowTitle';
import Details from '../components/Details';
import { useSidebarCallbacks } from '../hooks';
export default function DesktopProductCard() {
  const $ = _c(40);
  const {
    marketplaceEntity: t0
  } = useReviewContext();
  const {
    id: offerId,
    image: t1,
    showCTA
  } = t0;
  const {
    resizable: resizableImage,
    medium: mediumImage
  } = t1;
  const {
    containerRef
  } = useSidebarCallbacks();
  let t2;
  if ($[0] !== mediumImage.url || $[1] !== mediumImage.width || $[2] !== resizableImage) {
    t2 = customImageWidthURLBuilder(resizableImage, {
      customImageWidth: mediumImage.width,
      customImageQuality: 100,
      imageParentWidth: 180
    }, mediumImage.url);
    $[0] = mediumImage.url;
    $[1] = mediumImage.width;
    $[2] = resizableImage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    optimized
  } = t2;
  const hasAward = !!BEST_OF_AWARDS_WINNERS_MAP[offerId];
  let t3;
  if ($[4] !== offerId) {
    t3 = <BestOfAwardsBanner offerId={offerId} variant="review" isFeatureEnabled={true} />;
    $[4] = offerId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== hasAward) {
    t4 = hasAward && {
      borderTopColor: "transparent"
    };
    $[6] = hasAward;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = {
      display: "flex",
      pt: 3.5,
      px: 3.5,
      border: 1,
      borderColor: "neutral.lighter",
      ...t4
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== optimized.parentElement.width) {
    t6 = {
      width: optimized.parentElement.width,
      gap: 3
    };
    $[10] = optimized.parentElement.width;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = isNaN(optimized.parentElement.height) ? "100px" : optimized.parentElement.height;
  let t8;
  if ($[12] !== t7) {
    t8 = {
      position: "relative",
      height: t7,
      mb: 2
    };
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== optimized.image.url) {
    t9 = <CardImage source={optimized.image.url} />;
    $[14] = optimized.image.url;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <Box sx={t8}>{t9}</Box>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== optimized.parentElement.width || $[20] !== showCTA) {
    t11 = showCTA && <Box sx={{
      display: "flex",
      flexDirection: "column",
      width: optimized.parentElement.width
    }}><ApplyNowButton device="desktop" /><RatesAndFeesButton /></Box>;
    $[19] = optimized.parentElement.width;
    $[20] = showCTA;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== containerRef || $[23] !== t10 || $[24] !== t11 || $[25] !== t6) {
    t12 = <Box ref={containerRef} sx={t6}>{t10}{t11}</Box>;
    $[22] = containerRef;
    $[23] = t10;
    $[24] = t11;
    $[25] = t6;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      pl: 3.5,
      mb: 3.5,
      width: "100%"
    };
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== showCTA) {
    t14 = <ApplyNowTitle showCTA={showCTA} />;
    $[28] = showCTA;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Details />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14) {
    t16 = <Box sx={t13}>{t14}{t15}</Box>;
    $[31] = t14;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t12 || $[34] !== t16 || $[35] !== t5) {
    t17 = <Box sx={t5}>{t12}{t16}</Box>;
    $[33] = t12;
    $[34] = t16;
    $[35] = t5;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17 || $[38] !== t3) {
    t18 = <Box>{t3}{t17}</Box>;
    $[37] = t17;
    $[38] = t3;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
}